'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _MountainBackground = require('./artwork/MountainBackground');

var _MountainBackground2 = _interopRequireDefault(_MountainBackground);

var _MountainForeground = require('./artwork/MountainForeground');

var _MountainForeground2 = _interopRequireDefault(_MountainForeground);

var _MountainBackgroundSecondary = require('./artwork/MountainBackgroundSecondary');

var _MountainBackgroundSecondary2 = _interopRequireDefault(_MountainBackgroundSecondary);

var _ScoirWave = require('./artwork/ScoirWave');

var _ScoirWave2 = _interopRequireDefault(_ScoirWave);

var _Cloud = require('./artwork/Cloud');

var _Cloud2 = _interopRequireDefault(_Cloud);

var _Shark = require('./artwork/Shark');

var _Shark2 = _interopRequireDefault(_Shark);

require('./index.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FourOhFour = function FourOhFour(_ref) {
    var onGoHome = _ref.onGoHome;
    return _react2.default.createElement(
        'div',
        { className: 'four-oh-four-page-comp' },
        _react2.default.createElement(
            'div',
            { className: 'four-oh-four-sky' },
            _react2.default.createElement(_Cloud2.default, { className: 'cloud cloud-1' }),
            _react2.default.createElement(_Cloud2.default, { className: 'cloud cloud-2', lighter: true }),
            _react2.default.createElement(_Cloud2.default, { className: 'cloud cloud-3' }),
            _react2.default.createElement(_Cloud2.default, { className: 'cloud cloud-4', lighter: true }),
            _react2.default.createElement(
                'div',
                { className: 'four-oh-four-status' },
                '4',
                _react2.default.createElement(
                    'span',
                    { className: 'four-oh-four-sun' },
                    _react2.default.createElement(
                        'div',
                        { className: 'four-oh-four-rays' },
                        _react2.default.createElement('div', null),
                        _react2.default.createElement('div', null),
                        _react2.default.createElement('div', null),
                        _react2.default.createElement('div', null),
                        _react2.default.createElement('div', null),
                        _react2.default.createElement('div', null),
                        _react2.default.createElement('div', null),
                        _react2.default.createElement('div', null),
                        _react2.default.createElement('div', null)
                    )
                ),
                '4'
            ),
            _react2.default.createElement(
                'div',
                { className: 'four-oh-four-text' },
                'You seem to have gotten lost, time for you to find your way.'
            )
        ),
        _react2.default.createElement(
            'div',
            { className: 'four-oh-four-action' },
            _react2.default.createElement(
                'button',
                { onClick: onGoHome },
                'Go Home'
            )
        ),
        _react2.default.createElement(
            'div',
            { className: 'four-oh-four-land' },
            _react2.default.createElement(_MountainBackgroundSecondary2.default, { className: 'landmass mountain-background-secondary' }),
            _react2.default.createElement(_MountainBackground2.default, { className: 'landmass mountain-background' }),
            _react2.default.createElement(_MountainForeground2.default, { className: 'landmass mountain-foreground' })
        ),
        _react2.default.createElement(
            'div',
            { className: 'four-oh-four-sea' },
            _react2.default.createElement(_ScoirWave2.default, { className: 'scoir-wave' }),
            _react2.default.createElement(_Shark2.default, { className: 'shark shark-1' }),
            _react2.default.createElement(_Shark2.default, { className: 'shark shark-2', reversed: true })
        )
    );
};
FourOhFour.propTypes = {
    onGoHome: _propTypes2.default.func.isRequired
};
exports.default = FourOhFour;
//# sourceMappingURL=index.js.map